import searchMutations from '@/customer/vuex/mutations/search';
import filterMutations from '@/customer/vuex/mutations/filter';
import fieldsMutations from '@/customer/vuex/mutations/fields';
import remarkMutations from '@/customer/vuex/mutations/remarks';
import importMutations from '@/customer/vuex/mutations/import';
import remarkRuleMutations from '@/customer/vuex/mutations/remarkRule';

export default {
  ...searchMutations,
  ...filterMutations,
  ...fieldsMutations,
  ...remarkMutations,
  ...importMutations,
  ...remarkRuleMutations,
};
